import Typography from "components/typography";
import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import PrimaryButton from "components/buttons/primary-button";
import Modal from "components/modal";
import AddLinkModal from "../modals/addLinkModal";
import PlatformItem from "./platformItem";
import { GetActiveArtist } from "services/user/getUser";

import { UpdateArtistData } from "services/user/setUser";
import Toast from "components/toast";
import api from "services/axiosInstance";

const SocialMedia = () => {
  const EmptyData = {
    instagram: "",
    facebook: "",
    tiktok: "",
    x: ""
  };

  const HandleLinkChange = (value: string, platform: string) => {
    setLinks((prev) => ({ ...prev, [platform]: value }));
  };

  const Artist = GetActiveArtist();
  const [saving, setSaving] = useState(false);

  const [Links, setLinks] = useState(Artist?.socialMediaLinks || EmptyData);

  const canSave = useMemo(() => {
    return Object.values(Links).every((link) => link !== "") && Artist?.id;
  }, [Links, Artist?.id]);

  const OnSaveChanges = async () => {
    try {
      setSaving(true);

      const { data } = await api.patch(`/artists/${Artist?.id}`, {
        socialMediaLinks: Links
      });

      UpdateArtistData(data.data);
      Toast({
        type: "success",
        message: "Artist profile has been updated successfully"
      });
    } catch (error) {
      Toast({
        type: "error",
        message: "Something went wrong"
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container>
      <Header>
        <Typography weight="medium" size="2xl">
          Social Media
        </Typography>
      </Header>
      <Items>
        <PlatformItem
          platform={"Instagram"}
          link={Links.instagram}
          setLink={(link) => HandleLinkChange(link, "instagram")}
          disabled={Artist?.id ? false : true}
        />
        <PlatformItem
          platform="Facebook"
          link={Links.facebook}
          setLink={(link) => HandleLinkChange(link, "facebook")}
          disabled={Artist?.id ? false : true}
        />
        <PlatformItem
          platform="Tik Tok"
          link={Links.tiktok}
          setLink={(link) => HandleLinkChange(link, "tiktok")}
          disabled={Artist?.id ? false : true}
        />
        <PlatformItem
          platform="X"
          link={Links.x}
          setLink={(link) => HandleLinkChange(link, "x")}
          disabled={Artist?.id ? false : true}
        />
      </Items>
      <SaveButton>
        <PrimaryButton
          text="Save Changes"
          loading={saving}
          onClick={OnSaveChanges}
          disabled={!canSave}
        />
      </SaveButton>
    </Container>
  );
};

export default SocialMedia;

const Container = styled.div`
  width: 100%;
  background-color: rgba(30, 30, 30, 0.5);
  border-radius: 0.8rem;
  /* backdrop-filter: blur(5px); */
  padding: 2.4rem;
`;

const Header = styled.div`
  padding-bottom: 1.6rem;
  width: 100%;
  border-bottom: 0.5px solid ${Colors.grey600};
  margin-bottom: 1.6rem;
`;

const Items = styled.div`
  border: 0.5px solid ${Colors.grey600};
  border-top: none;
  border-radius: 0.6rem;
  :first-child {
    border-radius: 0.6rem;
  }
`;

const SaveButton = styled.div`
  width: fit-content;
  margin-top: 2.4rem;
  margin-left: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
